function initTelInput() {
    var itlOptions = {
        separateDialCode: true,
        preferredCountries: ["us"],
        initialCountry: ""
    };
    if ($('.js-int-phone').length) {
        $(".js-int-phone").each(function() {
            $(this).intlTelInput(itlOptions);
        });
    }
}

function maskUSPhoneNumbers(){
    var tel = $('#phone-number').intlTelInput('getSelectedCountryData');
    if (tel.iso2 == 'us') {
        $("#phone-number").inputmask("999-999-9999");
    } else {
        $("#phone-number").inputmask('remove');
        $('#phone-number').val("");
    }
}
$("#phone-number").on("countrychange", function(e) {
    maskUSPhoneNumbers();
});

$(document).ready(function(){
    initTelInput();
    setTimeout(function(){
        maskUSPhoneNumbers()
    }, 100);
});


$(window).on('resize orientationchange', function(){
    if ($('.js-int-phone').length) {
        $('.js-int-phone').each(function() {
            var selected = $(this).intlTelInput("getSelectedCountryData").iso2;
            $(this).intlTelInput('destroy');
            initTelInput();
            $(this).intlTelInput('setCountry', selected);
        });
        // $('.js-int-phone').each(function() {
           //  var $itiContainer = $(this).parents('.iti');
           //  var selectedFlagWidth = $itiContainer.find('.iti__selected-flag').outerWidth();
           //  // This size 6px hardcoded in plugin
           //  $(this).css("padding-left", "".concat(selectedFlagWidth + 6, "px") );
        // });
    }
})


